<template>
  <v-card
    class="studyManagerPage"
    :class="{
      'ma-6': !xs,
      'is-mobile': isMobile,
      'fit-to-space': !isMobile
    }"
  >
    <FusionStudyManager
      ref="studyManager"
      :columns="columns"
      :detailsDialogFields="detailsDialogFields"
      :showDetailsBtn="true"
      :showEditBtn="true"
      :showDeleteBtn="true"
      :showDoneBtn="false"
      :showSendToReportCreatorBtn="false"
      :studiesLeftToComplete="studiesLeftToComplete"
      :sortBy="sortBy"
      :sortDesc="sortDesc"
      :intervalRequest="intervalRequest"
      searchInputVariant="underlined"
      fixed-header
      fixed-footer
      data-cy="fusionStudyManager"
    >
    </FusionStudyManager>
  </v-card>
</template>

<script lang="ts">
import { defineComponent } from 'vue'
import type { DetailsDialogFields, StudyManagerTableColumnHeader } from '@fusion/saas-components-v3'
import { useDisplay } from 'vuetify'

export default defineComponent({
  name: 'StudyManager',

  setup() {
    const { xs, smAndDown } = useDisplay()
    return { xs, smAndDown }
  },

  data() {
    return {
      detailsDialogFields: {
        duration: true,
        device: true,
        location: true,
        study_type: true,
        total_samples: true,
        notes: true,
        gateway: true,
        sampling_interval: true,
        termination_reason: true
      } as DetailsDialogFields,
      studiesLeftToComplete: 0 as number,
      sortBy: 'formatted_start_time' as string,
      sortDesc: true as boolean,
      intervalRequest: 60 as number
    }
  },

  computed: {
    isMobile(): boolean {
      return this.smAndDown
    },
    columns(): StudyManagerTableColumnHeader[] {
      const columnsData: [string, string, string][] = [
        ['studyStartTime', 'formatted_start_time', '15%'],
        ['name', 'study_name', '20%'],
        ['moduleType', 'device_model', '15%'],
        ['location', 'location', '15%'],
        ['duration', 'duration', '130px'],
        ['deviceName', 'device_name', '15%'],
        ['notes', 'notes', '20%'],
        ['access', 'access', '90px']
      ]

      const columns: StudyManagerTableColumnHeader[] = columnsData.map(([i18nKey, key, width]) => ({
        title: this.$t(`studyManager.columns.${i18nKey}`),
        key,
        width
      }))

      columns.push({
        align: 'center',
        sortable: false,
        title: this.$t('studyManager.columns.actions'),
        key: 'actions',
        width: '50px'
      })

      return columns
    }
  }
})
</script>

<style lang="scss" scoped>
.studyManagerPage {
  :deep(.title) {
    font-weight: 300 !important;
    font-size: 1.5rem !important;
    line-height: 1.6;
  }

  :deep(.subtitle) {
    line-height: 1.425;
    padding-bottom: 0.25rem;
  }

  :deep(.studyManager__container) {
    flex-grow: 1;

    > :first-child {
      flex-grow: 0;
    }

    > .v-divider {
      margin-left: 16px;
      margin-right: 16px;
    }

    .v-table__wrapper {
      height: unset !important;
    }

    .v-data-table-footer {
      padding: 8px 16px;
    }

    .expand-collapse-buttons {
      margin-left: 0;
    }

    .studyManagerButtons {
      display: none !important;
    }
  }
}
</style>
